import {useEffect, useRef} from 'react';
import {getRealtimeMessages} from '../../../../../redux/realtime/realtimeActions';
import {useSelector} from 'react-redux';
import MobilePopup from '../../../../../component/newPopup/mobilePopup/MobilePopup';
import useShow from '../../../../../hooks/useShow';
import {BGImageCenter} from '../../../../../globalVariables/GlobalVariables';
import {TSystemMessage} from '../../../../../redux/realtime/realtime.type';
import SystemMessageSwiper from './systemMessageSwiper';
import setGlobalState from '../../../../../redux/setGlobalState';
import * as css from './systemMessage.css';

function SystemMessageDisplayPop({messagePreview, onClose,isPreview=false}:{messagePreview?: TSystemMessage, onClose?: any,isPreview?: boolean}){
    const  systemMessage = messagePreview? [messagePreview] : useSelector((s: any) => s.realtime.systemMessage?.popMessages);
    const displayPop = !!systemMessage?.find(m=>m.displayInPop);
    const show = useShow();
    const systemMessageXHR = useSelector((s:any) => s.realtime.getSystemMessageXHR);
    const isViewed = useSelector((s:any) => s.realtime.systemMessage.isViewed);
    const eid = useSelector((s:any) => s.event?.eid);
    const originalTitleRef = useRef(null);
    const isPopupOpenRef = useRef(false);
    const systemMessageTitle = 'system message - הודעת מערכת';

    useEffect(() => {
        if(!originalTitleRef.current) {
            originalTitleRef.current = document.title;
        }
        const isPopupOpen = show.isOpen;
        if(isPopupOpenRef.current && !isPopupOpen) {
            if(originalTitleRef.current) {
                document.title = originalTitleRef.current;
            }
        }

        if(isPopupOpen && !isPopupOpenRef.current) {
            const newTitle = `Tickchak | ${systemMessageTitle}`;
            document.title = newTitle;
        }
        isPopupOpenRef.current = isPopupOpen;
    }, [show.isOpen]);

    useEffect(()=>{
        if(!systemMessageXHR && eid)
            getRealtimeMessages();
        if(displayPop &&  (!isViewed || isPreview))
            show.open();
    },[]);
    useEffect(()=>{
        if(displayPop && (!isViewed || isPreview))
            show.open();
        else
            show.close();
    },[systemMessage]);
    
    const close = () => {
        show.close();
        onClose && onClose();
        setGlobalState('realtime.systemMessage.isViewed',true);
    };

    return (
        <css.wrapper>   
            {(displayPop || messagePreview) && show.isOpen? <MobilePopup
                showClass={show.showClass}
                close={close} 
                title={undefined}
                list={undefined}
                forwardRef={undefined}
                dataCyName={'systemMessagePop'}
                cssStyle={`height:380px; width:440px;
                ${ systemMessage?.image && BGImageCenter(systemMessage?.image, 'cover')};`}
            >
                <SystemMessageSwiper isPop={true} defaultMessages={systemMessage} />
            </MobilePopup>:<></>}
        </css.wrapper>
    );
}

export default SystemMessageDisplayPop;